// extracted by mini-css-extract-plugin
export default {"price":"C5-z","onSale":"D5-z","msrpLabelPrice":"E5-z","msrpLabel":"F5-z","originalPrice":"G5-z","percentOff":"H5-z"};